import { Controller } from 'stimulus'

export default class RateEscConfirmController extends Controller {
    connect () {
    }

}

import { application } from '../../frontend/controllers/index'
application.register("rate-esc-confirm", RateEscConfirmController)